var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNettopreisschnittstelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "83px",
    viewBox: "0 0 75 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944625 9.5,22.361625 9.5,23.516625 L9.5,51.384625 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384625 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944625 63.2245,20.367125 L39.09,6.433125 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.6%",
    y: "-9.5%",
    width: "143.2%",
    height: "138.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-nettopreisschnittstelle"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-color-gold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page01-teileidentifikation1",
    transform: "translate(-910.000000, -986.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/page-nav",
    transform: "translate(507.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nettopreis-schnittstelle",
    transform: "translate(403.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-nettopreisschnittstelle)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F3F4",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke-color",
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944125 9.5,22.361625 9.5,23.516625 L9.5,51.384125 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384125 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944125 63.2245,20.367125 L39.09,6.433125 Z",
    id: "border",
    stroke: "#666666",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,6 C36.8886346,6.01803249 36.2852285,6.15628155 35.8201132,6.42676886 L11.8092236,20.3859175 C10.8138273,20.9644598 10,22.3840172 10,23.5411018 L10,51.4588982 C10,52.6159828 10.8138273,54.0360411 11.8092236,54.6145834 L35.8201132,68.5732311 C36.2852285,68.8437184 36.8886346,68.9824684 37.5,69 L37.5,6 Z",
    id: "overlay",
    fill: "#666666",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(15.000000, 15.000000)",
    fill: "#676767"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M28.7327555,17.3581087 C28.7327555,17.7832714 28.5675583,18.182541 28.2671999,18.4828995 C27.6654472,19.0841343 26.6172996,19.0841343 26.0171005,18.4828995 C25.716742,18.182541 25.551027,17.7832714 25.551027,17.3581087 C25.551027,16.933464 25.716742,16.5336765 26.0171005,16.233318 C26.317459,15.9329595 26.7167286,15.7672445 27.1424091,15.7672445 C27.1812486,15.7672445 27.2185345,15.7760481 27.2573739,15.7786374 L27.0455694,15.9899241 C26.6411212,16.3943723 26.6411212,17.0505002 27.0455694,17.4549485 C27.2480524,17.6569136 27.5131965,17.7578962 27.7778227,17.7578962 C28.0429667,17.7578962 28.3081108,17.6569136 28.5100759,17.4549485 L28.7213626,17.2431439 C28.7244698,17.2819834 28.7327555,17.3192693 28.7327555,17.3581087 L28.7327555,17.3581087 Z M33.0781142,21.2021795 L19.7805191,34.4997746 L10.0002254,24.7199987 L23.3024813,11.4182608 L30.9792298,12.0567815 L28.8938098,14.1416837 C28.362486,13.8516824 27.7643583,13.6958067 27.1424091,13.6958067 C26.1636547,13.6958067 25.2439364,14.0769512 24.552594,14.7688115 C23.8607338,15.4601538 23.4795892,16.3798722 23.4795892,17.3581087 C23.4795892,18.3363453 23.8607338,19.2560636 24.552594,19.947406 C25.2439364,20.6392662 26.1636547,21.0204108 27.1424091,21.0204108 C28.1201278,21.0204108 29.040364,20.6392662 29.7317064,19.947406 C30.9046581,18.7744544 31.1118018,16.9971607 30.3567628,15.6082616 L32.3738253,13.5911991 L33.0781142,21.2021795 Z M36.1966638,8.30333618 C35.7922156,7.89888794 35.1366055,7.89888794 34.7321573,8.30333618 L32.8978991,10.1375944 L22.9953906,9.31419783 C22.6882999,9.287787 22.3920843,9.39860892 22.1771727,9.61403846 L7.80346564,23.9877455 C7.60926834,24.1819428 7.5,24.4455332 7.5,24.7199987 C7.5,24.9944643 7.60926834,25.2580547 7.80346564,25.452252 L19.0482658,36.6965344 C19.250231,36.8984995 19.5153751,37 19.7805191,37 C20.0456632,37 20.3102893,36.8984995 20.5127724,36.6965344 L34.8864794,22.3228273 C35.1044982,22.1053264 35.2137666,21.8018607 35.1852843,21.4947701 L34.2774767,11.6870299 L36.1966638,9.76784271 C36.6011121,9.36339448 36.6011121,8.70778441 36.1966638,8.30333618 L36.1966638,8.30333618 Z",
    id: "Fill-1"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNettopreisschnittstelle);
export default __webpack_public_path__ + "static/media/nettopreisschnittstelle.6447548c797d079e3467d0efc1fcca76.svg";
export { ForwardRef as ReactComponent };